import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("title", null, null, -1),
    _createElementVNode("g", {
      "data-name": "1",
      id: "_1"
    }, [
      _createElementVNode("path", { d: "M441.13,166.52h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" }),
      _createElementVNode("path", { d: "M441.13,279.72h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" }),
      _createElementVNode("path", { d: "M441.13,392.92h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" })
    ], -1)
  ])))
}